__turbopack_context__.v({
  "closeButton": "_2xlsxW_closeButton",
  "container": "_2xlsxW_container",
  "content": "_2xlsxW_content",
  "ctaButton": "_2xlsxW_ctaButton",
  "desktopContent": "_2xlsxW_desktopContent",
  "mobileContent": "_2xlsxW_mobileContent",
  "onlyTabletContent": "_2xlsxW_onlyTabletContent",
  "textContent": "_2xlsxW_textContent",
});
